
import { Button } from '../button/Button';

export function Filter({ setActiveButton, item }) {
  return (
    <Button
      onClick={() => {
        setActiveButton(item.dataId);
      }}
      disabled={item.disabled}
      variant={item.variant}
      fontWeight={item.fontWeight}
    >
      {item.text}
    </Button>
  );
}
